<!-- contact-page.vue -->
<template>
    <Layout>
    <div class="max-w-4xl mx-auto text-center pt-8">
      <h1 class="text-3xl text-left pl-4 pb-4">Conference Hall</h1>
      <p class="text-left pl-4 pb-4">For the benefit of the members of the community & general public, SGLM is providing the facility to rent out the conference hall that can seat 75-100 people. For details on rates and booking you can mail us on secretary@sglm.in or contact us on +91 99872 40404 or +91 22 2628 3715.</p>
      <p class="text-left pl-4 pb-4">Inauguration of conference hall was done on 15.8.2016 by Shri Satish Vithalani & Managing Trustee Shri Ajitbhai Thakkar.</p>
      <h1 class="text-3xl text-left pl-4 pb-4 pt-4">Conference Hall Photos</h1>
      <div class="grid grid-cols-3 gap-4 pl-4">
        <div v-for="image in conferenceHallImages" :key="image.name" class="overflow-hidden">
          <img :src="image.url" :alt="`Conference Hall Image ${image.name}`" class="w-full h-auto px-4 py-8">
        </div>
      </div>
      </div>
    </Layout>
  </template>
  
  <script>

  import Layout from './../layouts/LayoutView.vue'
  import axiosInstance from '@/utils/axiosInstance';

  export default {
    components: {
      Layout
    },
    data() {
    return {
        conferenceHallImages: [],
    };
  },
  computed: {
  },
  async created() {
    try {
      const response = await axiosInstance.get('home-page?populate[serviceLinkList][populate]=linkMedia'); 
      var responseAttributes = response.data.data.attributes;
      // Get all linkMedia images where linkUrl equals 'conference-hall'
      this.conferenceHallImages = responseAttributes.serviceLinkList
        .filter(item => item.linkUrl === '/conference-hall')
        .map(item => item.linkMedia.data[0].attributes);
      console.log(this.conferenceHallImages); // Log the images to verify

    } catch (error) {
      console.error('Failed to fetch About Us Page:', error);
      
    }
  },
}
  </script>
    